import { cva, type VariantProps } from 'class-variance-authority';
import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../../lib/utils';

// shadcn/ui-style button, written by hand. Sizes and colors follow docs/DESIGN.md §4.
export const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent disabled:pointer-events-none disabled:opacity-50',
  {
    variants: {
      variant: {
        /** One per screen: full width, 56px, accent. */
        primary:
          'min-h-14 w-full rounded-[18px] bg-accent px-5 text-base text-on-accent hover:bg-accent-hover',
        secondary:
          'min-h-12 rounded-2xl border border-line bg-transparent px-4 text-[15px] text-fg hover:bg-surface-2',
        ghost: 'min-h-11 rounded-2xl px-4 text-[15px] font-medium text-fg hover:bg-surface-2',
        danger:
          'min-h-12 rounded-2xl border border-danger bg-transparent px-4 text-[15px] text-danger hover:bg-surface-2',
        /** Compact accent action in a page header (e.g. "New account"). */
        small: 'min-h-11 rounded-2xl bg-accent px-4 text-sm text-on-accent hover:bg-accent-hover',
      },
      block: { true: 'w-full' },
    },
    defaultVariants: { variant: 'primary' },
  },
);

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> &
  VariantProps<typeof buttonVariants>;

export function Button({ className, variant, block, type = 'button', ...props }: ButtonProps) {
  return (
    <button type={type} className={cn(buttonVariants({ variant, block }), className)} {...props} />
  );
}
